import React, { useState, useEffect } from "react";
import { isNil } from "ramda";
import xmlParser from "helpers/xmlParser";
import convertTagsToHtml from "helpers/convertTagsToHtml";
import HTMLReactParser from "html-react-parser";
import { Container } from "./QuestionAnswer.styles";
import { Card, Grid, Input } from "@mantine/core";

const QuestionAnswer = ({ xml, qnType }) => {
  const filteredXml = !isNil(xml) ? xml.replace(/\\/g, "") : null;
  const [questionAnswers, setQuestionAnswers] = useState(null);

  useEffect(() => {
    if (!isNil(filteredXml)) {
      const parsed = xmlParser(filteredXml);
      if (qnType === "mcq") {
        setQuestionAnswers(
          parsed.mcqOptions.correctOptions.map((answer) => {
            return {
              Key: answer.refId,
              Value: HTMLReactParser(convertTagsToHtml(answer.content)),
            };
          })
        );
      } else {
        setQuestionAnswers(parsed.questionAnswers.map((answer) => answer.$));
      }
    }
  }, [filteredXml, qnType]);

  return (
    <Container data-cy="answer">
      <div className="answer-wrapper">
        {questionAnswers !== null &&
          questionAnswers.map((answer, index) => (
            <div key={answer.Key} style={{ width: 600, margin: "auto" }}>
              <Card padding="md" shadow="sm">
                <Card.Section style={{ padding: "20px" }}>
                  <Grid>
                    <Grid.Col span={3}>
                      <div>
                        <label>{`Answer ${index + 1}`}</label>
                      </div>
                    </Grid.Col>
                    <Grid.Col span={3}>
                      <div>
                        <label>Key</label>
                        <Input value={answer.Key} disabled />
                      </div>
                    </Grid.Col>
                    <Grid.Col span={3}>
                      <div>
                        <label>Value</label>
                        <Input value={answer.Value} disabled />
                      </div>
                    </Grid.Col>
                    <Grid.Col span={3}>
                      <div>
                        <label>Type</label>
                        <Input value={answer.Type} disabled />
                      </div>
                    </Grid.Col>
                  </Grid>
                </Card.Section>
              </Card>
            </div>
          ))}
      </div>
    </Container>
  );
};

export default QuestionAnswer;
